import React from "react";

// Package
import { Bar } from "react-chartjs-2";
import { Chart, CategoryScale, LinearScale, BarElement } from "chart.js";

export default function ReactChart() {
    // Register required Chart.js components
    Chart.register(LinearScale, CategoryScale, BarElement);

    // Data for the bar chart
    const data = {
        labels: ["S", "M", "T", "W", "T", "F", "S"],
        datasets: [
            {
                label: "Statistics",
                backgroundColor: "#1DA687", // Bar color
                barThickness: 12, // Bar thickness
                data: [1, 2, 3, 3, 2, 1, 4], // Bar values
            },
        ],
    };

    // Options for the bar chart
    const options = {
        scales: {
            x: {
                ticks: {
                    zeroLineWidth: 0,
                    zeroLineColor: "rgba(0, 0, 0, 0)",
                    color: "#AEA8A8", // Customize the color of x-axis labels
                    font: {
                        weight: "400", // Make x-axis labels bold
                        size: 12, // Adjust the font size of x-axis labels
                    },
                },
                grid: {
                    display: false, // Hide x-axis grid lines
                },
            },
            y: {
                type: "linear",
                beginAtZero: true,
                ticks: {
                    stepSize: 1,
                    color: "#AEA8A8", // Customize the color of y-axis labels
                    font: {
                        weight: "400", // Make y-axis labels bold
                        size: 12, // Adjust the font size of y-axis labels
                    },
                },
                grid: {
                    display: false, // Hide y-axis grid lines
                    color: "transparent",
                },
            },
        },
        plugins: {
            responsive: true, // Enable responsiveness of the chart
            title: {
                display: true,
                text: "Vertical Bar Chart", // Chart title
            },
        },
        borderRadius: 37, // Set the border radius of the bars
        borderSkipped: false, // Do not skip bar borders
    };

    return (
        <div>
            <Bar data={data} options={options} width={350} height={200} />
        </div>
    );
}
